import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { SceneTreeNode } from "../scene/SceneTreeItem";

/**
 * Type guard to check if a SceneNodeItem is of dataType "text"
 */
export function isSceneTextNode(node?: SceneNodeItem): node is SceneNodeItem<"text"> {
  if (!node) return false;
  return node.dataType === "text";
}

export function isTextTreeNode(treeNode: SceneTreeNode): treeNode is SceneTreeNode<"text"> {
  return treeNode.node.dataType === "text";
}
